export default "__VITE_ASSET__CCUU56Vo__"